module.exports = __webpack_public_path__ + "img/nauru.156f1a5.webp";